import { type FC } from "react";
import type { FallbackProps } from "react-error-boundary";
import { Alert, Button, Stack } from "@mui/material";
import { FormattedMessage } from "react-intl";

export const DefaultFallbackComponent: FC<FallbackProps> = ({ resetErrorBoundary }) => (
	<Stack
		sx={{
			alignItems: "center",
		}}
	>
		<Alert
			severity="error"
			sx={{ width: "fit-content" }}
			action={
				resetErrorBoundary ? (
					<Button color="inherit" size="small" onClick={resetErrorBoundary}>
						<FormattedMessage id="Try again" defaultMessage="Try again" />
					</Button>
				) : null
			}
		>
			<FormattedMessage id="An unexpected error occurred" defaultMessage="An unexpected error occurred" />
		</Alert>
	</Stack>
);
